import React from "react";
import { useNavigate } from "react-router-dom";
import { FaCheckCircle } from "react-icons/fa"; // وارد کردن آیکون
import "./orderSuccessPage.css";

const OrderSuccessPage = () => {
  const navigate = useNavigate();

  return (
    <div className="order-success-container">
      <FaCheckCircle className="success-icon" /> {/* آیکون تیک سبز */}
      <h1 className="order-success-message">
        سفارش شما ثبت شد و اطلاعات سفارش به ایمیل شما ارسال شد
      </h1>
      <button className="return-home-button" onClick={() => navigate("/")}>
        برگشت به خانه
      </button>
    </div>
  );
};

export default OrderSuccessPage;
